//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SpriteIcon from '../elements/SpriteIcon';
import FlexButtonGroup from '../flex/FlexButtonGroup';

export default {
    components: {
        SpriteIcon,
        FlexButtonGroup,
    },
    props: {
        lang: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            disableDuringAction: false,
            accepted_sepa_mandate_terms: false,
            sepa: {
                birth_date: '',
                birth_place: '',
            },
            errors: { },
            customer: {
                firstName: '',
                lastName: '',
            },
            pricing: { },
        }
    },
    methods: {
        handlePrevious(step = -1)
        {
            window.dataLayer?.push( { 'event': 'step4prev' } );

            this.$nextTick( () => this.$emit('previous', step ) );
        },

        handleSubmit()
        {
            this.disableDuringAction = true;

            const data = this.sepa;

            data.query_string = window.__app?.query_string || '';

            this.$app.get('axios').post('/api/funnel/payment?lang=' + this.lang, data ).then( response => {
                if ( response.data.url ) {
                    window.dataLayer?.push( { 'event': 'step4digiteal' } );

                    this.$nextTick( () => {
                        window.location = response.data.url;
                    } );

                    return;
                } else {
                    this.errors = response.data.errors;

                    this.$el.parentElement.scrollIntoView({ behavior: 'smooth' })

                    this.$forceUpdate();
                }

                this.disableDuringAction = false;
            } ).catch( () => {
                this.disableDuringAction = false;
            } );
        },
    },

    created() {
        this.$app.get('axios').get('/api/funnel/user?lang=' + this.lang).then( response => {
            if ( response.data === false || response.data.billingZipCode === null ) {
                this.handlePrevious( 0 );
            }

            this.customer = response.data;
        } );

        this.$app.get('axios').get('/api/funnel/pricing?lang=' + this.lang).then( response => {
            this.pricing = response.data;
        } );
    },

    mounted() {
        window.dataLayer?.push( { 'event': 'step4in' } );
    }
}
